<template>
  <v-dialog :value="sectionEditor.show" :width="1000" @input="handleClosePopup">
    <div style="background-color: #fff">
      <div class="header-modal">
        <v-card-title class="d-flex justify-space-between align-center" style="padding: 10px 0">
          <span style="color: #0081c7">{{ fields['title'] }}</span>
          <v-btn icon @click="handleClosePopup">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
      </div>
      <v-card-text>
        <div class="mb-4">
          <label class="label-input">Section Name</label>
          <v-row>
            <v-col cols="12" md="8">
              <div>
                <v-text-field v-model="fields['title']" label="Name" />
              </div>
            </v-col>
            <v-col cols="12" md="4">
              <v-checkbox small v-model="fields['enableAnchor']" label="Enable Anchor" />
            </v-col>
          </v-row>
        </div>
        <div>
          <label class="label-input">Content</label>
          <div>
            <v-select
              :value="fields['card-left']"
              :items="postionOptions"
              label="Title Position"
              @change="handleChangePositionLeft"
            />
            <label>Card Title</label>
            <ckeditor :editor="editor" v-model="fields['card-title']" :config="editorConfig" />
          </div>

          <v-row class="mt-5">
            <v-col cols="6">
              <div style="margin-bottom: 20px">
                <div>
                  <div class="d-flex align-center gap-3">
                    <input
                      type="color"
                      name="title-color"
                      style="width: 40px; height: 40px; margin-right: 12px"
                      :value="fields['title-color']"
                      @change="handleChangeTitleColor"
                    />
                    <v-text-field v-model="fields['title-color']" label="Title Color" />
                    <v-btn @click="handleResetTitleColor" small text color="primary"> Reset </v-btn>
                  </div>
                </div>
              </div>
            </v-col>
            <v-col cols="6">
              <div style="margin-bottom: 20px">
                <div>
                  <div class="d-flex align-center gap-3">
                    <input
                      type="color"
                      name="background-color"
                      style="width: 40px; height: 40px; margin-right: 12px"
                      :value="fields['background-color']"
                      @change="handleChangeBackgroundColor"
                    />
                    <v-text-field v-model="fields['background-color']" label="Background Color" />
                    <v-btn @click="handleResetBackgroundColor" small text color="primary"> Reset </v-btn>
                  </div>
                </div>
              </div>
            </v-col>
          </v-row>
          <div>
            <label class="label-input">Images Before and After</label>
            <v-row class="mt-5">
              <v-col cols="6">
                <div class="">
                  <div class="text-center font-weight-bold">Before</div>
                  <div>
                    <v-text-field v-model="fields.imageBefore.text" label="Text" />
                  </div>
                  <div>
                    <div class="d-flex align-center gap-3">
                      <input
                        type="color"
                        name="text-color"
                        style="width: 40px; height: 40px; margin-right: 12px"
                        :value="fields.imageBefore.colorDecor"
                        @change="handleChangeColorDecor($event, 'before')"
                      />
                      <v-text-field v-model="fields.imageBefore.colorDecor" label="Text Color" />
                    </div>
                  </div>
                  <div>
                    <div class="d-flex align-center gap-3">
                      <input
                        type="color"
                        name="bg-color"
                        style="width: 40px; height: 40px; margin-right: 12px"
                        :value="fields.imageBefore.bgDecor"
                        @change="handleChangeBgDecor($event, 'before')"
                      />
                      <v-text-field v-model="fields.imageBefore.bgDecor" label="Background Color" />
                    </div>
                  </div>
                  <div class="mb-5">
                    <label> Image Before</label>
                    <UploadImage
                      @callback="obj => handleUploadImage(obj, 'before')"
                      :image="{ imageSrc: fields.imageBefore.img }"
                      :height="`250`"
                      :typeUpload="'image'"
                      @callbackDelete="handleRemoveUploadBefore"
                    />
                  </div>
                </div>
              </v-col>
              <v-col cols="6">
                <div class="">
                  <div class="text-center font-weight-bold">After</div>
                  <div>
                    <v-text-field v-model="fields.imageAfter.text" label="Text" />
                  </div>
                  <div>
                    <div class="d-flex align-center gap-3">
                      <input
                        type="color"
                        name="text-color"
                        style="width: 40px; height: 40px; margin-right: 12px"
                        :value="fields.imageAfter.colorDecor"
                        @change="handleChangeColorDecor($event, 'after')"
                      />
                      <v-text-field v-model="fields.imageAfter.colorDecor" label="Text Color" />
                    </div>
                  </div>
                  <div>
                    <div class="d-flex align-center gap-3">
                      <input
                        type="color"
                        name="bg-color"
                        style="width: 40px; height: 40px; margin-right: 12px"
                        :value="fields.imageAfter.bgDecor"
                        @change="handleChangeBgDecor($event, 'after')"
                      />
                      <v-text-field v-model="fields.imageAfter.bgDecor" label="Background Color" />
                    </div>
                  </div>
                  <div class="mb-5">
                    <label> Image After</label>
                    <UploadImage
                      @callback="obj => handleUploadImage(obj, 'after')"
                      :image="{ imageSrc: fields.imageAfter.img }"
                      :height="`250`"
                      :typeUpload="'image'"
                      @callbackDelete="handleRemoveUploadAfter"
                    />
                  </div>
                </div>
              </v-col>
            </v-row>
          </div>
        </div>
      </v-card-text>
      <div class="footer-modal">
        <v-card-actions style="padding: 10px 0">
          <v-spacer></v-spacer>
          <v-btn min-width="100" depressed @click="handleClosePopup">Cancel</v-btn>
          <v-btn min-width="100" color="primary" @click="handleSave">Save</v-btn>
        </v-card-actions>
      </div>
    </div>
  </v-dialog>
</template>

<script>
import Editor from 'ckeditor5-custom-build/build/ckeditor';
import { ckeditorConfigFullToolbar } from '@/helpers/editor';
import { updateHtmlFromData } from '@/views/website/products/components/description/common/html/update';
import UploadImage from '@/components/form/uploadFile/UpdateImage.vue';
export default {
  name: 'card-compare-two-image-section-editor',
  components: {
    UploadImage,
  },
  props: {
    sectionEditor: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      editor: Editor,
      editorConfig: ckeditorConfigFullToolbar,
      postionOptions: [
        {
          text: 'Left',
          value: 1,
        },
        {
          text: 'Right',
          value: 2,
        },
      ],
      fields: {
        title: '',
        'card-left': 1,
        'card-right': 2,
        'card-title': '',
        'title-color': '',
        'background-color': '',
        imageBefore: {
          text: '',
          bgDecor: '',
          colorDecor: '',
        },
        imageAfter: {
          text: '',
          bgDecor: '',
          colorDecor: '',
        },
      },
    };
  },
  mounted() {
    this.fields = {
      ...this.fields,
      ...this.sectionEditor.sectionExtract,
    };
  },
  methods: {
    handleClosePopup() {
      this.$emit('close');
    },
    handleChangePositionLeft(value) {
      this.fields['card-left'] = Number(value);
      if (value === 1) {
        this.fields['card-right'] = 2;
      } else {
        this.fields['card-right'] = 1;
      }
    },
    handleChangeBgDecor(e, type) {
      if (type === 'before') {
        this.fields.imageBefore.bgDecor = e.target.value;
      } else {
        this.fields.imageAfter.bgDecor = e.target.value;
      }
    },
    handleChangeColorDecor(e, type) {
      if (type === 'before') {
        this.fields.imageBefore.colorDecor = e.target.value;
      } else {
        this.fields.imageAfter.colorDecor = e.target.value;
      }
    },
    handleChangeTitleColor(event) {
      this.fields['title-color'] = event.target.value;
    },
    handleChangeBackgroundColor(event) {
      this.fields['background-color'] = event.target.value;
    },
    handleResetTitleColor() {
      this.fields['title-color'] = '';
    },
    handleResetBackgroundColor() {
      this.fields['background-color'] = '';
    },
    handleUploadImage(obj, type) {
      if (type === 'before') {
        this.fields.imageBefore.img = obj.imageSrc;
      } else {
        this.fields.imageAfter.img = obj.imageSrc;
      }
    },
    handleRemoveUploadBefore() {
      this.fields.imageBefore.img = '';
    },
    handleRemoveUploadAfter() {
      this.fields.imageAfter.img = '';
    },
    handleSave() {
      const updateHtml = updateHtmlFromData.sectionCompareTwoImg(this.sectionEditor.section.html, this.fields);
      this.$emit('update:section', {
        ...this.sectionEditor.section,
        title: this.fields['title'],
        html: updateHtml,
      });
      this.$emit('close');
    },
  },
};
</script>

<style lang="scss" scoped>
.ck-editor__editable_inline {
  height: 200px;
  //   min-height: 200px;
}
.ck-editor__editable {
  height: 200px;
  //   min-height: 200px;
}
.label-input {
  font-size: 18px !important;
  font-weight: 500;
  color: #000;
  margin-bottom: 10px;
  display: block;
}
.header-modal {
  position: sticky;
  top: 0;
  left: 0;
  z-index: 999;
  background-color: #fff;
  padding: 0 16px;
  box-shadow: 0px 0px 12px #0000000f;
}
.footer-modal {
  position: sticky;
  padding: 0 16px;
  bottom: 0;
  left: 0;
  z-index: 999;
  background-color: #fff;
  box-shadow: 0px 0px 12px #0000000f;
}
</style>
